import React from 'react';

import styled from 'styled-components';

import { MediaQueryMax } from '^/constants/styles';
import * as T from '^/types';
import animationData from '^/assets/lotties/logo-lottie.json';
import Lottie from 'lottie-react';
import RetroGrid from '^/components/molecules/RetroGrid';
import colorTokens from '^/theme/colors/color-tokens';

const AuthLayoutContainer = styled.div({
  position: 'relative',
  display: 'grid',
  padding: '20px',
  height: '100%',
  width: '100%',
  gridTemplateColumns: 'minmax(min-content, 800px) 1fr',
  boxSizing: 'border-box',
  gap: '10px',

  [MediaQueryMax[T.Device.DESKTOP]]: {
    gridTemplateColumns: '1fr',
  },
});

const ChildrenWrapper = styled.div({
  boxSizing: 'border-box',
  overflowY: 'auto',
});
const ImageWrapper = styled.div({
  position: 'relative',
  height: '100%',
  width: '100%',
  minWidth: '500px',
  gap: '16px',
  background: colorTokens.bgBlack,
  boxSizing: 'border-box',
  backgroundSize: 'cover',
  borderRadius: '20px',
  paddingLeft: '100px',
  paddingRight: '100px',
  display: 'flex',
  overflow: 'hidden',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',

  [MediaQueryMax[T.Device.DESKTOP]]: {
    display: 'none',
  },
});

const SloganText = styled.span({
  zIndex: '1',
  color: '#FFF',
  fontSize: '12px',
  fontWeight: '400',
  fontStyle: 'normal',
  lineHeight: 'normal',
  whiteSpace: 'nowrap',
  letterSpacing: '4.8px',
  fontFamily: 'pretendard, sans-serif',
});

const AuthLayout = ({ children }: { children: React.ReactNode }) => (
  <AuthLayoutContainer>
    <ChildrenWrapper className="no-scrollbar">{children}</ChildrenWrapper>
    <ImageWrapper>
      <RetroGrid theme="dark" />
      <SloganText>DIGITAL TWIN FOR OUR PLANET</SloganText>
      <Lottie animationData={animationData} loop={false} />
    </ImageWrapper>
  </AuthLayoutContainer>
);
export default AuthLayout;
